export enum Role {
  Admin = 'administrador',
  Normal = 'regular',
  Student = 'estudante',
  Collaborator = 'colaborador',
}
